import React from "react"
import Logo from "../Logo/Logo"
import Navigation from "../Navigation/Navigation"
import S from "./StyledTopMenu"
import HamburgerMenu from "react-hamburger-menu"
import MediaQuery from "react-responsive"

class TopMenu extends React.Component {
  state = {
    isTop: true,
    open: false,
  }

  componentDidMount() {
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 250
      if (isTop !== this.state.isTop) {
        this.setState({ isTop })
      }
    })
  }

  handleClick() {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    return (
      <S.TopMenuParent>
        <S.TopMenuWrapper>
          <S.TopMenu>
            <Logo isTop={this.state.isTop}></Logo>
            <S.NavBtnWrapper>
              <Navigation isOpen={this.state.open} isTop={this.state.isTop} />
              <MediaQuery maxWidth={1280}>
                <HamburgerMenu
                  width={20}
                  height={15}
                  isOpen={this.state.open}
                  menuClicked={this.handleClick.bind(this)}
                />
              </MediaQuery>
            </S.NavBtnWrapper>
          </S.TopMenu>
        </S.TopMenuWrapper>
      </S.TopMenuParent>
    )
  }
}

export default TopMenu
